import {bootstrapApplication} from '@angular/platform-browser';
import {enableProdMode, isDevMode} from '@angular/core';

import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {environment} from './environment';

// Check for a production environment then enable production mode.
if (environment.production) enableProdMode();

// Define the app name on the window object for telemetry purposes.
// This is used by the telemetry service to identify the application in which telemetry events are being tracked.
(window as any).appNameEnvMode = 'lakshmi-integ-prism-' + (isDevMode() ? 'debug' : 'release');

// Bootstrap the application
bootstrapApplication(AppComponent, appConfig).catch((error): void => console.error(error));
